<template>
    <div>
        <nav class="navbar page-header p-0">
            <a href="#" class="btn btn-link sidebar-mobile-toggle d-md-none mr-auto">
                <i class="fa fa-bars"></i>
            </a>
            <a class="navbar-brand ml-3" href="/">
                <img class="img-fluid" src="@/assets/now-micro-logo.png" alt="logo">
            </a>
            <a href="#" class="btn btn-link sidebar-toggle d-md-down-none">
                <i class="fa fa-bars"></i>
            </a>
            <a class="navbar-nav ml-auto mr-2"><h3 v-if="storedOrg" style="padding-left: 175px">{{storedOrg}}</h3></a>
            <ul v-if="!user" class="navbar-nav ml-auto mr-3">
                <li class="nav-item">
                    <button v-on:click="login" id="login" class="btn btn-primary mr-1 ml-auto">
                        <i class="fa fa-sign-in"></i> Login
                    </button>
                </li>
            </ul>
            <UserService v-if="user" v-bind="{user, logout}"></UserService>
        </nav>
    </div>
</template>



<script>
     import 'bootstrap/dist/css/bootstrap.css'
    import 'bootstrap-vue/dist/bootstrap-vue.css'
    import Mgr from '@/services/SecurityService'
    import UserService from '@/components/general/UserService.vue';

    export default {
         props: {
            user: Object,
            logout: Function,
            login: Function
        },
        components: {
            UserService
        },
        data: function () {
            return {
                mgr: new Mgr(),
                storedOrg: JSON.parse(localStorage.getItem("org")),
                
            }
        }
    }
</script>
